export * from './technician-storage-view.component'